import { createAsyncThunk } from "@reduxjs/toolkit";

import { IOtpRequest, IUserOtp } from "models/Otp/otp.model";
import { Otp } from "services/otp.service";

export const otpAsync = createAsyncThunk(
  "Otp",
  async (otpReq: IOtpRequest): Promise<IUserOtp> => {
    try {
      const response = await Otp(otpReq);
      return response;
    } catch (error: any) {
      throw error;
    }
  }
);
